import React, { memo } from 'react'

import Avatar from 'app/components/base/Avatar'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import LocationWithUserRating from 'app/features/Store/components/LocationWithUserRating'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import NameWithLabel from './components/NameWithLabel'

interface StoreUserInfoFeatureProps {
  avatarUrl?: string
  location?: string
  loading?: boolean
  rating?: number
  name?: string
  role?: string
}

const StoreUserInfoFeature: RFC<StoreUserInfoFeatureProps> = ({
  avatarUrl,
  location,
  loading,
  rating,
  name,
  role = 'personal'
}) => {
  const showLocationWithUserRating = !!location || !!rating

  return (
    <Stack spacing={2}>
      <Stack spacing={{ md: 4, xs: 2 }} direction="row">
        <Avatar
          src={avatarUrl}
          sizes="150px"
          width={74}
          height={74}
          loading={loading}
          sx={{
            width: { md: 94, xs: 74 },
            height: { md: 94, xs: 74 },
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'background.default',
            backgroundColor: IS_NATIVE_APP ? 'primary.main' : 'inherit',
            ...(loading && { backgroundColor: 'border.main' })
          }}
          {...(IS_NATIVE_APP && { layout: 'fill', sizes: '256px' })}
        />

        <Stack spacing={1} justifyContent="center" sx={{ flex: 1 }}>
          <Skeleton
            loading={loading}
            sx={{
              backgroundColor: 'border.main',
              width: '45%',
              height: 50
            }}
          >
            <NameWithLabel name={name} role={role} />
          </Skeleton>

          {!IS_NATIVE_APP && showLocationWithUserRating && (
            <LocationWithUserRating
              location={location}
              isLoading={loading}
              rating={rating}
              sx={{ display: { md: 'flex', xs: 'none' } }}
            />
          )}
        </Stack>
      </Stack>

      {showLocationWithUserRating && (
        <LocationWithUserRating
          location={location}
          isLoading={loading}
          rating={rating}
          sx={{ display: { md: 'none', xs: 'flex' } }}
        />
      )}
    </Stack>
  )
}

export default memo(StoreUserInfoFeature)
